
import { drawShapes as _drawShapes, updateActiveShapes as _updateActiveShapes, updateAndDrawShapes, updateShapesPanZoom } from "../../shared/render/shapes";
import { mat3 as _mat3 } from "gl-matrix";
import { g as _g } from "../../shared/globalState/g";
import { a } from "../../shared/globalState/a";
import { t as _t } from "../../shared/globalState/t";
import { applyTransformationToPoint as _applyTransformationToPoint, getRealScale } from "../../shared/common";


// --- rxjs
import { fromEvent as _fromEvent } from "rxjs";
import { clearTooltipAll } from "../../services/tooltip";

function handleMouseWheel(ev) {
    if (a.blockUI) return;
    clearTooltipAll();
    a.zl = ev.deltaY > 0 ? 0.90 : 1.1;
    a.zlc *= a.zl;
    updateShapesPanZoom('zoom');
    updateAndDrawShapes();


    a.realScale$.next(getRealScale());


}
function updateZoomLevel(newZoomLevel) {
    
    a.shapes.forEach(shape => {
        shape.zoom(newZoomLevel);
    })
    updateAndDrawShapes();


    a.realScale$.next(getRealScale());
}

export { handleMouseWheel, updateZoomLevel }